import ChangePassword from "../ChangePassword";

const NewPassword = () => {
  return (
    <div>
        <ChangePassword method={1} email={''} />
    </div>
  );
};

export default NewPassword;
